export default "__VITE_ASSET__CJfdYVxE__"